<template>
	<div class="row filter-nav align-center">
		<div class="columns column12">
			<span
				class="button filter-button"
				:class="{ active: filter === 'showAll' }"
				@click="$emit('change-filter', 'showAll')"
				>{{ $t('showAll') }}</span
			>
			<span
				v-for="item in items"
				:key="item"
				class="button filter-button"
				:class="{ active: filter === item }"
				@click="$emit('change-filter', item)"
				>{{ item }}</span
			>
		</div>
	</div>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
	filter: { type: String, default: 'showAll' },
});

defineEmits(['change-filter']);
</script>

<style lang="scss" scoped>
.filter-nav {
	margin: 0 auto 50px;
	display: flex;
	flex-wrap: wrap;

	span {
		cursor: pointer;
		padding: 10px 15px;
		text-transform: uppercase;
		margin: 3px 3px 0 0;
		transition: all 0.3s ease-in-out;
		background: var(--primary-background-color);
		color: #000;
		text-decoration: none;
		font-weight: 700;
		letter-spacing: 1px;
		font-size: 13px;

		&.active {
			background: var(--button-color);
			border-color: var(--button-color);
			color: #fff;
		}
	}
}
</style>
